import { render, staticRenderFns } from "./ReporteDocente.vue?vue&type=template&id=91e9d9b2&"
import script from "./ReporteDocente.vue?vue&type=script&lang=js&"
export * from "./ReporteDocente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports